import ky from 'ky';
import { API_URL } from './env/.env';
const client = ky.extend({
    prefixUrl: API_URL
});
export async function fetchBills(payload) {
    try {
        const data = await client.get(`marketplace/bills/?${payload}`).json();
        return data;
    }
    catch (error) {
        console.error(error);
    }
}
export async function fetchMakers(payload) {
    try {
        const data = await client.get(`marketplace/makers/?${payload}`).json();
        return data;
    }
    catch (error) {
        console.error(error);
    }
}
export function fetchBillCategories() {
    return client.get(`marketplace/bill-categories`).json();
}
export function fetchMakerCategories() {
    return client.get(`marketplace/maker-categories`).json();
}
